import type { ConfigType } from '@plone/registry';

import updateAccordionConfig from './accordion';
import updateLarguraConfig from './largura';
import updateSlateConfig from './slate';
import updateTabsConfig from './tabs';

/**
 * Ajustes nos blocos que não são nossos — os do core e os dos add-ons de
 * terceiros. Um arquivo por bloco estendido; os blocos do portal são
 * registrados no `../index.ts`.
 *
 * A exceção é o `largura`, que atravessa TODOS os blocos do portal de uma vez
 * e por isso não caberia no registro de nenhum deles.
 */
export const applyBlockEnhancers = (config: ConfigType) => {
  updateAccordionConfig(config);
  updateLarguraConfig(config);
  updateSlateConfig(config);
  updateTabsConfig(config);
  return config;
};

export default applyBlockEnhancers;
